import axios from '@/util/axios'
import { NEW_API_CONFIG, DEV_API_TOKEN } from '@/util/constants'
import store from '@/store'
import { handleApiError as handleError } from '@/util/axios_common'

/**
 * [検索用]パッケージ・商品一覧API(認証ありページ用)
 * @param  {} params={}
 */
export const listPackagesAndProductsForSearch = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = { 
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/QA/001', r).catch(handleError)
}

/**
 * [任意選択用]パッケージ・商品一覧API(認証ありページ用)
 * @param  {} params={}
 */
export const listPackagesAndProductsForAll = (params = {}) => {
  params.all = true
  return listPackagesAndProductsForSearch(params)
}

/**
 * [検索用]書籍一覧API
 * @param  {} params={}
 */
export const listBooksForSearch = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = { 
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/QA/002', r).catch(handleError)
}

/**
 * [選択用]書籍一覧API
 * @param  {} params={}
 */
export const listBooksForAll = (params = {}) => {
  params.all = true
  return listBooksForSearch(params)
}

/**
 * 書籍目次書式DL一覧API
 * @param  {} params={}
 */
export const listBooksAndFormDownloads = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = { 
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/QA/003', r).catch(handleError)
}

/**
 * 書籍目次一覧API
 * @param  {} params={}
 */
export const listBookTableOfContents = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = { 
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/QA/004', r).catch(handleError)
}

/**
 * QA一覧API
 * @param  {} params={}
 */
export const list = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = { 
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/QA/005', r).catch(handleError)
}

/**
 * リビジョン一覧API（リビジョン切替用）
 * @param  {} params={}
 */
export const listRevisionsForChange = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = { 
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/QA/008', r).catch(handleError)
}

/**
 * リビジョン一覧API（リビジョン選択用）
 * @param  {} params={}
 */
export const listRevisionsForChoice = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = { 
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/QA/018', r).catch(handleError)
}

/**
 * 書籍情報取得API
 * @param  {} params={}
 */
export const fetchBookInfo = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = { 
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/QA/009', r).catch(handleError)
}

/**
 * QA詳細取得API
 * @param  {} params={}
 */
export const detail = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = { 
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/QA/010', r).catch(handleError)
}

/**
 * 関連情報一覧API
 * @param  {} params={}
 */
export const listBookExampleRelatedInfo = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = { 
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/QA/011', r).catch(handleError)
}

/**
 * 関連情報・内容現在ページ取得API（WLJP連携）
 * @param  {} params={}
 */
export const fetchBookExampleRelatedPage = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = { 
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/QA/012', r).catch(handleError)
}

/**
 * 内容現在一覧API
 * @param  {} params={}
 */
export const listBookExampleRelatedContents = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = { 
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/QA/013', r).catch(handleError)
}

/**
 * 書式DL一覧API
 * @param  {} params={}
 */
export const listFormDownloads = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = { 
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/QA/014', r).catch(handleError)
}

/**
 * キーワード検索結果件数取得API
 * @param  {} params={}
 */
export const countKeywordSearchResults = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = { 
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/QA/015', r).catch(handleError)
}

/**
 * 裁判所一覧取得API
 * @param  {} params={}
 */
export const listCourts = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = { 
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/QA/016', r).catch(handleError)
}

/**
 * 単行本オプション書籍情報取得API
 * @param  {} params={}
 */
export const fetchMonographOptionBook = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id
  
  const r = { 
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/QA/019', r).catch(handleError)
}

/**
 * 単行本オプション表示判定API
 * @param  {} params={}
 */
export const isVisibleMonographOptionBook = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id
  
  const r = { 
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/QA/020', r).catch(handleError)
}
